
import { Services } from "slotworks/services/services";
import { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import SmartUIFlags from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";
import Timer from "slotworks/utils/timer";

export default class Autoplay extends State {

    public static WAIT: number = 0;

    private waitTimer: number;

    public onEnter() {
        SmartUIFlags.set(SmartUIFlag.IDLE, false);
        Services.autoplay.spin();

        if (Autoplay.WAIT > 0) {
            this.waitTimer = Timer.setTimeout(() => this.complete(), Autoplay.WAIT);
        } else {
            this.complete();
        }
    }

    public onSkip() {
        Timer.clearTimeout(this.waitTimer);

        this.skip();
    }
}
